// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-img {
    position: fixed;top: 100px; right: 0px;
}
.hide-img {
    position: absolute;
}`, "",{"version":3,"sources":["webpack://./src/app/_layout/private-layout/private-layout.component.css"],"names":[],"mappings":"AAAA;IACI,eAAe,CAAC,UAAU,EAAE,UAAU;AAC1C;AACA;IACI,kBAAkB;AACtB","sourcesContent":[".add-img {\n    position: fixed;top: 100px; right: 0px;\n}\n.hide-img {\n    position: absolute;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
